module.exports = __webpack_public_path__ + "img/logo02_sp.4fd4f8e0.png";